/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Reconnect/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ApiToken from './ApiToken/index'
import No from './No/index'
import OAuth2 from './OAuth2/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Reconnect({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ReconnectAction/Content/Reconnect"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ApiToken'}>
<ApiToken
  viewPath={`${viewPath}/ApiToken`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OAuth2'}>
<OAuth2
  viewPath={`${viewPath}/OAuth2`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}